import React from 'react'

import {AiChatPrompt} from "../../../../../core/gd-modules/ai-chat/@type"
import UI5ControlButton from "../../../../../layout/app-controls/buttons/button/button"
import {ButtonSize} from "../../../../../core/gd-components/buttons/gd-button/gd-button-ui5-new"

type Props = {
    className?          : string

    onSelect            : callback,
    suggestedActions?   : AiChatPrompt[]

}

export default function AIChat_SuggestedActions(props: Props) {

    const classes = Classes("flex-column-left-top", props.className)

    if (!props.suggestedActions) {
        return null
    }

    return (
        <div className={classes}>
            <div style={{display: "flex", flexWrap: "wrap", gap: "8px"}}>
                {_.map(props.suggestedActions, (option: AiChatPrompt, key: number)=>{
                    const onClick = () => props.onSelect(option.message)

                    return (
                        <UI5ControlButton
                            className   = "suggested-action-chip p-h-5"
                            key         = {key}
                            color       = "gray"
                            iconClass   = "i5-suggested-reply"
                            label       = {option.title}
                            size        = {ButtonSize.SMALLER}
                            fontSize    = "13"
                            labelSize   = "13"
                            onClick     = {onClick}
                        />
                    )
                })}
            </div>
        </div>
    )
}
